import { clearExplorerSessionOnLogout } from "../explorer/explorerSession";

export type AuthTokens = {
  accessToken: string;
  refreshToken: string;
  expiresAtUtc?: string;
  userObjectId?: string;
  email?: string;
};

const ACCESS_TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";
const EXPIRES_AT_UTC_KEY = "access_expires_at_utc";
const USER_OBJECT_ID_KEY = "objectId";
const EMAIL_KEY = "auth_email";

export function getAccessToken(): string {
  return localStorage.getItem(ACCESS_TOKEN_KEY) || "";
}

export function getAccessTokenObjectId(): string {
  const token = getAccessToken();
  if (!token) return "";

  try {
    const [, payloadRaw] = token.split(".");
    if (!payloadRaw) return "";
    const base64 = payloadRaw.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    const payload = JSON.parse(atob(padded));
    return typeof payload?.oid === "string" ? payload.oid : "";
  } catch {
    return "";
  }
}

export function getRefreshToken(): string {
  return localStorage.getItem(REFRESH_TOKEN_KEY) || "";
}

export function setTokens(tokens: AuthTokens) {
  localStorage.setItem(ACCESS_TOKEN_KEY, tokens.accessToken);
  localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refreshToken);
  if (tokens.expiresAtUtc) localStorage.setItem(EXPIRES_AT_UTC_KEY, tokens.expiresAtUtc);
  if (tokens.userObjectId) localStorage.setItem(USER_OBJECT_ID_KEY, tokens.userObjectId);
  if (tokens.email) localStorage.setItem(EMAIL_KEY, tokens.email);
}

export function clearTokens() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(EXPIRES_AT_UTC_KEY);
  localStorage.removeItem(EMAIL_KEY);
  // keep objectId? we clear it so app doesn't think user is logged in
  localStorage.removeItem(USER_OBJECT_ID_KEY);
  /** Per-tab explorer / registration draft state must not survive logout. */
  clearExplorerSessionOnLogout();
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("smbf-logout"));
  }
}

export function isLoggedIn(): boolean {
  return !!getAccessToken();
}

